function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useLocation, matchPath } from "react-router-dom";
import { useLayoutEffect, useRef } from "react";

// Routes with tabs where switching tabs shouldn't trigger scroll
var TABBED_ROUTES = ["/home/:activeTab", "/wallet/:activeTab", "/goals/:activeTab", "/edit-goal/:activeTab", "/boosts/:activeTab", "/brokers/:brokerId/:activeTab", "/goals/:goalId/:activeTab", "/no-goal/:activeTab", "/investment-items/:investmentItemId/:activeTab", "/users/:username/:activeTab"];

/**
 * Extracts the base path (without the activeTab segment) if the pathname
 * matches the given pattern.
 */
function getBasePathForRoute(pathname, pattern) {
  var match = matchPath({
    path: pattern,
    end: true
  }, pathname);
  if (!match) return null;

  // Remove the last segment (activeTab) to get the base path
  var segments = pathname.split("/").filter(Boolean);
  segments.pop();
  return "/" + segments.join("/");
}

/**
 * Finds the base path for a pathname if it matches any tabbed route pattern.
 */
function findMatchingBase(pathname) {
  var _iterator = _createForOfIteratorHelper(TABBED_ROUTES),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var pattern = _step.value;
      var basePath = getBasePathForRoute(pathname, pattern);
      if (basePath) return basePath;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}
function ScrollToTop() {
  var location = useLocation();
  var prevPathnameRef = useRef(null);
  useLayoutEffect(function () {
    var prevPathname = prevPathnameRef.current;
    var currentPathname = location.pathname;

    // Update ref for next navigation
    prevPathnameRef.current = currentPathname;

    // Check if navigating within the same tabbed section
    if (prevPathname !== null) {
      var currentBase = findMatchingBase(currentPathname);
      var prevBase = findMatchingBase(prevPathname);

      // Skip scroll if both paths are in the same tabbed section
      if (currentBase && prevBase && currentBase === prevBase) {
        return;
      }
    }

    // Scroll to top for initial load or when changing sections
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, [location.pathname]);
  return null;
}
export default ScrollToTop;